/* YOSEEN 配色v1: 把主题自带 quick buy(就地下拉)呈现为居中弹窗 */
(function () {
  var HTML = document.documentElement;

  function anyOpen() {
    return document.querySelector('.quickbuy-container.qv-open');
  }

  function containerOf(e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('quickbuy-container')) return t;
    return t && t.closest ? t.closest('.quickbuy-container') : null;
  }

  document.addEventListener('on:quickbuy:before-open', function (e) {
    var c = containerOf(e);
    if (!c) return;
    document.querySelectorAll('.quickbuy-container.qv-open').forEach(function (o) {
      if (o !== c) o.classList.remove('qv-open');
    });
    c.classList.add('qv-open');
    HTML.classList.add('quickview-open');
  });

  function cleanupAll() {
    document.querySelectorAll('.quickbuy-container.qv-open').forEach(function (o) {
      o.classList.remove('qv-open');
    });
    HTML.classList.remove('quickview-open');
  }

  document.addEventListener('on:quickbuy:after-close', cleanupAll);

  function closeOpen() {
    var c = anyOpen();
    if (!c) return;
    var x = c.querySelector('.close-detail');
    if (x) {
      x.click();
    } else {
      c.classList.remove('qv-open');
      HTML.classList.remove('quickview-open');
    }
  }

  // 点击遮罩(容器空白处,非内容区)关闭
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.quickbuy-toggle')) return;
    var c = anyOpen();
    if (!c) return;
    var insideInner = e.target.closest && e.target.closest('.quickbuy-container .inner');
    var insideThis = e.target.closest && e.target.closest('.quickbuy-container') === c;
    if (e.target === c || (insideThis && !insideInner)) closeOpen();
  });

  // Esc 关闭
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOpen();
  });

  // 悬停预加载商品页, 点开更快(桌面)
  var prefetched = {};
  document.addEventListener('mouseover', function (e) {
    var toggle = e.target.closest ? e.target.closest('.quickbuy-toggle') : null;
    if (!toggle) return;
    var url = toggle.getAttribute('href');
    if (!url || url === '#' || prefetched[url]) return;
    prefetched[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  });
})();
